import { ReactComponent as IconDataRequested } from "@/assets/svgs/package-data-requested.svg";
import { ReactComponent as IconX } from "@/assets/svgs/x-circle.svg";
import { BADGE_STATUS } from "../utils/get-package-status";
import PropTypes from 'prop-types';
import StatusTags, { STATUS } from '@/componentsDS/Tags/StatusTags';
import Tags from '@/componentsDS/Tags/Tags';

export default function StatusBadge({ badge }) {
	return (
		<>
			{badge === BADGE_STATUS.newData && <StatusTags status={STATUS.NEW_DATA} />}
			{badge === BADGE_STATUS.dataRequested && (
				<Tags
					label='Data Requested'
					prefixIcon={<IconDataRequested />}
					tagClassName="package-card__status-DS--requested"
				/>
			)}
			{badge === BADGE_STATUS.packageRequested && (
				<Tags
					label='Package Requested'
					prefixIcon={<IconDataRequested />}
					tagClassName="package-card__status-DS--requested"
				/>
			)}
			{badge === BADGE_STATUS.sent && <StatusTags status={STATUS.SENDING} />}
			{badge === BADGE_STATUS.delivered && <StatusTags status={STATUS.SENT} />}
			{badge === BADGE_STATUS.received && <StatusTags status={STATUS.RECEIVED} />}
			{badge === BADGE_STATUS.packageDeclined && (
				<Tags
					label='Declined'
					prefixIcon={<IconX />}
					tagClassName="package-card__status-DS--declined"
				/>
			)}
			{(badge === BADGE_STATUS.deliveryFailed || badge === BADGE_STATUS.receiveFailed) && (
				<StatusTags status={STATUS.FAILED} />
			)}
			{(!badge || badge === BADGE_STATUS.readyToSend || badge === BADGE_STATUS.inProgress) && (
				<StatusTags status={STATUS.IN_PROGRESS} />
			)}
		</>
	)
}

StatusBadge.propTypes = {
	badge: PropTypes.string
}
